import React from "react";
import {strings} from "../../../strings/strings";
import {Button} from "../../../components/Button";

export const ReglamentMessage = ({homeUrl, errorMessage1, errorMessage2}) => {
    return (
        <>
            <h1>{errorMessage1}</h1>
            <h1>{errorMessage2}</h1>
            <Button label={strings.toMainPage}
                    onClickListener={() => window.location.replace(homeUrl)}/>
        </>
    )
};